export const cardProps = {
  dark: true,
  color: 'primary',
  class: 'card',
}
